
import React from 'react';
import { Helmet } from 'react-helmet';

const TermsOfUsePage = () => {
  return (
    <div className="bg-secondary text-text-light py-24">
      <Helmet>
        <title>Terms of Use | Aletheia Systems</title>
        <meta name="description" content="Read the terms of use for the Aletheia Systems website and services. This document outlines your rights and responsibilities when using our platform." />
      </Helmet>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-extrabold text-center mb-12">Terms of Use</h1>
        <div className="prose prose-invert max-w-none">
          <p>Welcome to Aletheia Systems. By accessing our website, you agree to these Terms of Use. These terms govern your use of our website and services. Please read them carefully.</p>

          <h2>1. Acceptance of Terms</h2>
          <p>By using our website, you agree to be bound by these Terms of Use, our Privacy Policy, and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.</p>

          <h2>2. Use License</h2>
          <p>Permission is granted to temporarily download one copy of the materials on Aletheia Systems' website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
          <ul>
            <li>modify or copy the materials;</li>
            <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
            <li>attempt to decompile or reverse engineer any software contained on Aletheia Systems' website;</li>
            <li>remove any copyright or other proprietary notations from the materials; or</li>
            <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
          </ul>
          <p>This license shall automatically terminate if you violate any of these restrictions and may be terminated by Aletheia Systems at any time.</p>

          <h2>3. Disclaimer</h2>
          <p>The materials on Aletheia Systems' website are provided on an 'as is' basis. Aletheia Systems makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>

          <h2>4. Limitations</h2>
          <p>In no event shall Aletheia Systems or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Aletheia Systems' website, even if Aletheia Systems or a Aletheia Systems authorized representative has been notified orally or in writing of the possibility of such damage.</p>

          <h2>5. Accuracy of Materials</h2>
          <p>The materials appearing on Aletheia Systems' website could include technical, typographical, or photographic errors. Aletheia Systems does not warrant that any of the materials on its website are accurate, complete or current. Aletheia Systems may make changes to the materials contained on its website at any time without notice. However Aletheia Systems does not make any commitment to update the materials.</p>

          <h2>6. Links</h2>
          <p>Aletheia Systems has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Aletheia Systems of the site. Use of any such linked website is at the user's own risk.</p>

          <h2>7. Modifications</h2>
          <p>Aletheia Systems may revise these terms of use for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of use.</p>

          <h2>8. Governing Law</h2>
          <p>These terms and conditions are governed by and construed in accordance with the laws of Georgia and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUsePage;
